"use client";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useState } from "react";
import { useSearchGroup } from "@travel/shared/hooks";
export var OverlayRouterContext = createContext([
    {},
    {
        add: function () { },
        remove: function () { },
        push: function () { },
        replace: function () { },
    },
]);
export function OverlayRouterProvider(_a) {
    var children = _a.children;
    var _b = __read(useState([]), 2), overlayParams = _b[0], setOverlayParams = _b[1];
    var _c = __read(useSearchGroup(overlayParams), 2), params = _c[0], _d = _c[1], pushURL = _d.push, replaceURL = _d.replace;
    var add = useCallback(function (id) {
        if (overlayParams.indexOf(id) > -1)
            return;
        var next = __spreadArray(__spreadArray([], __read(overlayParams), false), [id], false);
        setOverlayParams(next);
    }, [overlayParams]);
    var remove = useCallback(function (id) {
        var index = overlayParams.indexOf(id);
        if (index < 0)
            return;
        var next = __spreadArray([], __read(overlayParams), false);
        next.splice(index, 1);
        setOverlayParams(next);
    }, [overlayParams]);
    var push = useCallback(function (id, isOpen) {
        /*
      pushURL({
        ...params,
        [id]: String(isOpen)
      });
       */
    }, [pushURL]);
    var replace = useCallback(function (id, isOpen) {
        var _a;
        pushURL(__assign(__assign({}, params), (_a = {}, _a[id] = isOpen, _a)));
    }, [pushURL]);
    return (_jsx(OverlayRouterContext.Provider, { value: [
            params,
            {
                add: add,
                remove: remove,
                push: push,
                replace: replace,
            },
        ], children: children }));
}
